import React, { useState } from "react";
import { useCurrentUserQuery } from "../../../../../../../../api/queries/useUserQuery";
import { QUALIPHY_EXAM_STATUS } from "../../../../../../../../consts/api";
import { useAppTranslation } from "../../../../../../../../i18n/useAppTranslation";
import { Skeleton } from "../../../../../../../../shared/Skeleton/Skeleton";
import { useQualiphyResendExamMutation } from "../../../../../../../../api/qualiphy/useQualiphyResendExamMutation";
import { uiNotification } from "../../../../../../../../services/UINotificationService";
import { CircularProgress } from "../../../../../../../../shared/CircularProgress/CircularProgress";
import { extractApiError } from "../../../../../../../../utilities/api";
import { Button } from "../../../../../../../../shared/Button/Button";
import { useContext } from "../../context";
import { history } from "../../../../../../../../history";
import { CLIENTS_ROUTES } from "../../../../../../../../consts/routes";
import { ModalCreateQualiphyProcedure } from "../../../../../../../../widgets/ModalCreateQualiphyProcedure/ModalCreateQualiphyProcedure";

export function ButtonQualiphyStatus() {
  const { tCommon } = useAppTranslation.Common();
  const { data: user } = useCurrentUserQuery();

  const {
    appointment,
    refetchAppointment,
    isAppointmentFetching,
    refetchAppointments,
  } = useContext();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const onRequestSuccess = async () => {
    setIsModalOpen(false);
    refetchAppointment();
    refetchAppointments();
  };

  const resendMutation = useQualiphyResendExamMutation({
    onError: (e) => {
      const msg = extractApiError(e);
      uiNotification.error(
        tCommon([`apiError.qualiphy.${msg}`, "error.qualiphy.resend"]),
      );
    },
    onSuccess: onRequestSuccess,
  });

  const resend = () => {
    resendMutation.mutate({
      clinicId: Number(appointment.clinic.id),
      appointmentId: Number(appointment.id),
    });
  };

  const redirectToPatientProfile = () => {
    const id = appointment.patient?.id;
    if (id) {
      history.push(CLIENTS_ROUTES.profile(id));
    }
  };

  const render = () => {
    if (isAppointmentFetching) {
      return <Skeleton width="154px" height={36} />;
    }
    if (user?.account?.integrations?.isQualiphyEnabled) {
      const buttonsByExamStatus = {
        [QUALIPHY_EXAM_STATUS.notExist]: (
          <Button size="small" onClick={() => setIsModalOpen(true)}>
            {tCommon("appointmentDetailsModal.qualiphyBtn.notExist")}
          </Button>
        ),
        [QUALIPHY_EXAM_STATUS.sent]: (
          <Button color="gray" size="small" onClick={redirectToPatientProfile}>
            {tCommon("appointmentDetailsModal.qualiphyBtn.sent")}
          </Button>
        ),
        [QUALIPHY_EXAM_STATUS.received]: (
          <Button
            color="success"
            size="small"
            onClick={redirectToPatientProfile}
          >
            {tCommon("appointmentDetailsModal.qualiphyBtn.received")}
          </Button>
        ),
        [QUALIPHY_EXAM_STATUS.error]: (
          <Button
            color="error"
            size="small"
            onClick={redirectToPatientProfile}
            leftAdornment={
              <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
            }
          >
            {tCommon("appointmentDetailsModal.qualiphyBtn.error")}
          </Button>
        ),
        [QUALIPHY_EXAM_STATUS.expired]: (
          <Button
            color="error"
            size="small"
            onClick={resend}
            isDisabled={resendMutation.isLoading}
            leftAdornment={
              resendMutation.isLoading ? (
                <CircularProgress color="white" size="small" />
              ) : undefined
            }
          >
            {tCommon("appointmentDetailsModal.qualiphyBtn.expired")}
          </Button>
        ),
      };

      return (
        <>
          {buttonsByExamStatus?.[appointment.examStatus] || null}
          {isModalOpen && (
            <ModalCreateQualiphyProcedure
              isOpen
              onClose={() => setIsModalOpen(false)}
              onSuccess={onRequestSuccess}
              appointmentId={appointment.id}
              patientId={appointment.patient?.id}
              initialValues={{
                clinicId: appointment.clinic?.id,
              }}
            />
          )}
        </>
      );
    }

    return null;
  };

  return render();
}
